$(function () {
  var formFields = [
    {name: "billingFirstName", required: true},
    {name: "billingLastName", required: true},
    {name: "billingEmail", required: true},
    {
      name: "billingPhone", required: true, regexp: function (input, form) {
        var phone = input.value.replace(/-|\s+/g, "");
        if (input.value && !/^(\+[0-9]{2})*[0-9]{9}$/g.test(phone)) {
          return false;
        }
        return true;
      }
    },
    {name: "billingStreet", required: true},
    {name: "billingHouseNumber", required: true},
    {
      name: "billingZip",
      required: true,
      regexp: function (input, form) {
        var postcode = input.value.replace(/\s+/g, "");
        if (postcode && !/^[0-9]{2}-[0-9]{3}$/g.test(postcode)) {
          return false;
        }
        return true;
      }
    },
    {name: "billingCity", required: true},
    {
      name: "bankAccount",
      required: function (input, form) {
        if (form.elements.resolveType && form.elements.resolveType.value !== "bankAccount") {
          return true;
        }
        return !!input.value;
      },
      regexp: function (input, form) {
        if (form.elements.resolveType && form.elements.resolveType.value !== "bankAccount") {
          return true;
        }
        var account = input.value.replace(/-|\s+/g, "");
        return /^[0-9]{26}$/.test(account);
      }
    },
  ];
  if (!document.forms.returnForm) {
    return
  }
  $('form[name="returnForm"] select').select2();
  $('form[name="complaintForm"] select').select2();
  $('form[name="returnForm"] .confirm-return').click(function (evt) {
    evt.preventDefault();
    Forms.clearFormErrors(document.forms.returnForm);
    var errors = Forms.validateFields(document.forms.returnForm, formFields);
    if (errors.length === 0) {
      document.forms.returnForm.submit();
    }
  });
  $('form[name="complaintForm"] .confirm-return').click(function (evt) {
    evt.preventDefault();
    Forms.clearFormErrors(document.forms.complaintForm);
    var errors = Forms.validateFields(document.forms.complaintForm, formFields);
    if (errors.length === 0) {
      document.forms.complaintForm.submit();
    }
  });
});